// extracted by mini-css-extract-plugin
module.exports = {"underline-offset-9":"styles_underline-offset-9__MyHgP","w-fit":"styles_w-fit__4VMeU","basis-6":"styles_basis-6__Fc5Sn"};